import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useMemo } from "react"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import { useCollection, useDeleteCollection, useUpdateCollection } from "../../hooks/collections"
import { initialValuesCollection, validationSchemaCollection } from "./CollectionCommon"
import CollectionForm from "./CollectionForm"
import type { Collection } from "../../types"

export default function CollectionUpdate() {
  const updateCollection = useUpdateCollection()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: collection } = useCollection(Number(id))

  const deleteCollection = useDeleteCollection()

  const [modalStateDeleteCollection, modalActionsDeleteCollection] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesCollection(collection), [collection])
  const validationSchema = useMemo(() => validationSchemaCollection(), [])

  useBreadcrumbs([{ label: "Raccolte", href: "/collections/collections" }, { label: "Dettaglio Raccolta" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{collection?.name}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteCollection.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return updateCollection.mutateAsync(values as Collection).then(() => {
                navigate(`/collections/collections`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <CollectionForm />
                </Container>
                <BottomFormFixed url="/collections/collections" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteCollection.isOpen}
        onClose={modalActionsDeleteCollection.close}
        onDelete={() => {
          return deleteCollection.mutateAsync(collection?.id).then(() => {
            navigate(`/collections/collections`)
          })
        }}
        message="Sei sicuro di voler eliminare la raccolta?"
        title="Elimina Raccolta"
      />
    </Layout>
  )
}
